import React, { Component } from 'react';
import { createCombineReducers } from 'mt-react-common/modules/payment/reducers/paymentForm/combine';
import PaymentForm from './PaymentForm';

class StatusesDescTableRWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `paymentForm`
    };
  }

  componentWillMount() {
    createCombineReducers(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <PaymentForm {...this.props} reducerName={this.state.reducerName} />
      </React.Fragment>
    );
  }
}

export default StatusesDescTableRWrapper;



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentForm/index.js